import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { CalendarDays } from "lucide-react";
import { todayLuanda } from "../../lib/utils";

const shift = (iso, days) => {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

export const PRESETS = [
  { id: "today", label: "Hoje", range: () => { const t = todayLuanda(); return [t, t]; } },
  { id: "yesterday", label: "Ontem", range: () => { const y = shift(todayLuanda(), -1); return [y, y]; } },
  { id: "7d", label: "Últimos 7 dias", range: () => { const t = todayLuanda(); return [shift(t, -6), t]; } },
  { id: "month", label: "Este mês", range: () => { const t = todayLuanda(); return [`${t.slice(0, 7)}-01`, t]; } },
  { id: "prev_month", label: "Mês passado", range: () => { const t = todayLuanda(); const first = new Date(`${t.slice(0, 7)}-01T12:00:00Z`); first.setUTCMonth(first.getUTCMonth() - 1); const s = first.toISOString().slice(0, 10); return [s, shift(`${t.slice(0, 7)}-01`, -1)]; } },
  { id: "custom", label: "Personalizado", range: null },
];

// Barra de filtros do relatório: período (atalhos + datas), categoria e "mostrar sem vendas"
export const ReportFilterBar = ({ filters, onChange, categories }) => {
  const [preset, setPreset] = useState("today");
  const pick = (p) => {
    setPreset(p.id);
    if (p.range) { const [s, e] = p.range(); onChange({ ...filters, start: s, end: e }); }
  };
  return (
    <div className="rounded-xl border bg-card p-4 space-y-3" data-testid="report-filter-bar">
      <div className="flex flex-wrap gap-1.5" data-testid="report-period-presets">
        {PRESETS.map((p) => (
          <Button key={p.id} size="sm" variant={preset === p.id ? "default" : "outline"} className="h-8 rounded-full" onClick={() => pick(p)} data-testid={`report-preset-${p.id}`}>{p.label}</Button>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-[auto_auto_1fr_auto] gap-3 items-end">
        <div className="space-y-1">
          <Label className="text-xs flex items-center gap-1"><CalendarDays className="w-3 h-3" /> De</Label>
          <Input type="date" value={filters.start} max={filters.end} onChange={(e) => { setPreset("custom"); onChange({ ...filters, start: e.target.value }); }} className="h-9 w-full md:w-40" data-testid="report-start-date" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Até</Label>
          <Input type="date" value={filters.end} min={filters.start} max={todayLuanda()} onChange={(e) => { setPreset("custom"); onChange({ ...filters, end: e.target.value }); }} className="h-9 w-full md:w-40" data-testid="report-end-date" />
        </div>
        <div className="space-y-1 col-span-2 md:col-span-1">
          <Label className="text-xs">Categoria</Label>
          <Select value={filters.category_id || "all"} onValueChange={(v) => onChange({ ...filters, category_id: v === "all" ? "" : v })}>
            <SelectTrigger className="h-9 md:max-w-xs" data-testid="report-category-select"><SelectValue placeholder="Todas as categorias" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todas as categorias</SelectItem>
              {categories.map((c) => <SelectItem key={c.category_id} value={c.category_id} data-testid={`report-category-${c.category_id}`}>{c.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <label className="flex items-center gap-2 text-xs h-9 col-span-2 md:col-span-1 cursor-pointer">
          <Switch checked={filters.include_unsold} onCheckedChange={(v) => onChange({ ...filters, include_unsold: v })} data-testid="report-include-unsold" />
          Mostrar produtos sem vendas
        </label>
      </div>
    </div>
  );
};
